import { LicenseInfo } from "@mui/x-license";
import { NerdSecurityAgentWrapper } from "@nerdjs/nerd-core";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { ConfirmProvider } from "material-ui-confirm";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { access } from "./access";
import { AppConfig } from "./environement";
import ExcelExport from "./hooks/excel/nerdExcel";
import { Helmet } from "react-helmet";
import { NerdAlpha } from "./hooks/nerdAlpha/nerdAlpha";
import NerdApp from "./hooks/nerdApp/nerdApp";
import { VersionChecker } from "./hooks/versionChecker/versionChecker";
import "./i18n";
import "./index.css";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import AskQuestion from "./hooks/askQuestion";
import { SyncCurrentUserTalentUuid } from "./hooks/talent/useSyncCurrentUserTalentUuid";

if (import.meta.env.PROD && import.meta.env.MODE !== "debug") {
  Sentry.init({
    dsn: "https://cdf242cf4dc44566b6dc88237793a769@o1058683.ingest.sentry.io/6046515",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

LicenseInfo.setLicenseKey(
  "544dfb3ca23b0b71595e437001c775baTz0xMTk2NjAsRT0xNzkwNDY3MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root container was not found");
}

createRoot(rootElement).render(
  // <React.StrictMode>
  <>
    <Helmet>
      <title>{AppConfig.app.alphaWatermark ? "FILMS (Alpha)" : "FILMS"}</title>
    </Helmet>
    {AppConfig.app.alphaWatermark ? <NerdAlpha /> : []}
    <NerdSecurityAgentWrapper access={access}>
      <BrowserRouter>
        <AskQuestion>
          <ConfirmProvider>
            <Provider store={store}>
              <SyncCurrentUserTalentUuid />
              <VersionChecker
                versionCheckerEndpoint={AppConfig.api.versionCheckerEndpoint}
              >
                <ExcelExport>
                  <NerdApp />
                </ExcelExport>
              </VersionChecker>
            </Provider>
          </ConfirmProvider>
        </AskQuestion>
      </BrowserRouter>
    </NerdSecurityAgentWrapper>
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
